import {
  CompassIcon,
  HandoutIcon,
  SearchUserIcon,
} from '../../../components/icons'

const Advantages = () => {
  return (
    <div className="container-fluid p-5">
      <h2 className="display-3 m-0 text-center mb-4">
        Les avantages du service Mobiville
      </h2>

      <div className="container-xl row mx-auto">
        <div className="col-12 col-md text-center mt-4 mx-md-4 my-md-0">
          <CompassIcon className="text-primary" size="lg" />
          <h3 className="t2 m-3">Identifiez une ville qui vous correspond</h3>
          <p>
            Mobiville vous donne une visibilité sur le marché de l’emploi, de
            l’immobilier et le cadre de vie afin de choisir une ville qui
            correspond à votre profil.
          </p>
        </div>
        <div className="col-12 col-md text-center mt-4 mx-md-4 my-md-0">
          <SearchUserIcon className="text-primary" size={48} />
          <h3 className="t2 m-3">Ciblez un territoire avec peu de candidats</h3>
          <p>
            Notre service vous propose en priorité les villes avec peu de
            candidats sur le territoire afin d’optimiser votre recherche
            d’emploi.
          </p>
        </div>
        <div className="col-12 col-md text-center mt-4 mx-md-4 my-md-0">
          <HandoutIcon className="text-primary" size="lg" />
          <h3 className="t2 m-3">Des conseils et des aides pour votre projet</h3>
          <p>
            Découvrez des conseils et des aides financières, administratives ou
            humaines que vous pouvez mobiliser dans votre projet.
          </p>
        </div>
      </div>
    </div>
  )
}

export default Advantages
